import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '70%',
  padding: '2rem 1.5rem',
  gap: '1.5rem',
  color: theme.palette.common.white,
}));

export const paperStyles = {
  style: {
    backgroundColor: theme.palette.primary.main,
    width: '100%',
    maxWidth: '38rem',
    borderRadius: '.5rem',
  },
};

export const Flex = styled('div')(() => ({
  display: 'flex',
  gap: '1rem',
}));

export const CloseIconStyled = styled(CloseIcon)(() => ({
  cursor: 'pointer',
}));

export const TitleContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: '1.5rem',
}));

export const SecondaryContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
}));

export const EmailAndPhone = styled('div')(() => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
  },
}));

export const AlignButtons = styled('div')(() => ({
  display: 'flex',
  gap: '1rem',
  flexDirection: 'column',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignSelf: 'self-end',
  },
}));
